import { styled } from 'stitches.config'

export const FloatingCtaRoot = styled('div', {
  position: 'fixed',
  bottom: 0,
  left: 0,
  width: '100%',
  backgroundColor: '$tertiary-200',
  padding: '$2',
  display: 'flex',
  flexDirection: 'column',
  gap: '$1',
  alignItems: 'center',
  justifyContent: 'center',
  zIndex: 1,
  opacity: 0.95,
  '@bp1': {
    display: 'none',
  },
})
